"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShootSubmissionSchema = void 0;
const joi_1 = __importDefault(require("joi"));
exports.ShootSubmissionSchema = joi_1.default.object({
    createdAt: joi_1.default.date().allow(null),
    endDateTime: joi_1.default.date().allow(null),
    name: joi_1.default.string().required(),
    organizationUuid: joi_1.default.string().uuid().allow(null),
    salesforceId: joi_1.default.string().required(),
    startDateTime: joi_1.default.date().allow(null),
    status: joi_1.default.string().allow(null),
    updatedAt: joi_1.default.date().allow(null),
    deliveredAt: joi_1.default.date().allow(null),
    uuid: joi_1.default.string().uuid().allow(null),
    linkToSubmission: joi_1.default.string().uri().allow(null),
    linkToCustomerSubmission: joi_1.default.string().uri().allow(null),
    externalReference: joi_1.default.string().allow(null),
    rescheduling: joi_1.default.string().allow(null),
    reschedulingDetail: joi_1.default.string().allow(null),
    cancelledBy: joi_1.default.string().allow(null, 'Location', 'Photographer', 'Customer', 'Lemon One'),
    cancellationTimeFrame: joi_1.default.string().allow(null, '>72h', '48-72h', '24-48h', '12-24h', '1-12h', '<1h'),
    photoshootCustomerFeedback: joi_1.default.string().allow(null),
    price: joi_1.default.number().allow(null),
    completionNotificationSent: joi_1.default.bool()
}).meta({ className: 'ShootSubmission' });
//# sourceMappingURL=ShootSubmissionSchema.js.map